import React from 'react';

/**
 * Props:
 * - id: string
 * - name: string
 * - checked: boolean
 * - onChange: (e) => void
 * - onCheckedChange?: (bool) => void
 * - onSave?: () => void               // <-- NEW: call this to save
 * - saving?: boolean                  // <-- NEW: controls button disabled/label
 * - saveLabel?: string                // <-- NEW: defaults to "Save"
 * - label?: React.ReactNode
 * - title?: string
 * - disabled?: boolean
 * - style?: React.CSSProperties
 * - className?: string
 */
export default function ToggleSwitch({
  id,
  name,
  checked,
  onChange,
  onCheckedChange,
  onSave,
  saving,
  saveLabel = 'Save',
  label,
  title,
  disabled,
  style,
  className = '',
}) {
  const handleChange = (e) => {
    onChange && onChange(e);
    onCheckedChange && onCheckedChange(e.target.checked);
  };

  return (
    <div
      className={`ios-switch ${className}`}
      title={title}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8, ...style }}
    >
      <label
        htmlFor={id}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <input
          id={id}
          name={name}
          type="checkbox"
          checked={!!checked}
          onChange={handleChange}
          disabled={disabled}
          role="switch"
          aria-checked={!!checked}
        />
        {label ? <span>{label}</span> : null}
      </label>
    </div>
  );
}
